import { render } from "./BContainer.vue?vue&type=template&id=4d73cbbf"
const script = {}

import exportComponent from "/Users/brianng/Documents/GitHub/SupaFoundationWeb2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__